import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import HomePage from './components/HomePage';
import PaymentPage from './components/PaymentPage';
import ThankYouPage from './components/ThankYouPage';
import AdminPage from './components/AdminPage';
import RoulettePage from './components/RoulettePage';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/roulette" element={<RoulettePage />} />
      </Routes>
    </Router>
  );
}
